import { once } from "@utils/general";
import memoize from "@utils/memoize";

import { getTranslations } from "@redux/modules/value/translations/translations.selector";

const translateKey = (
    translations: any,
    key: string,
    params: Array<string | number | undefined> = [],
) => {
    const mappedKey = Object.keys(translations || {}).find(
        k => k.toLowerCase() === key.toLowerCase(),
    );
    if (mappedKey) {
        const translatedKey = translations[mappedKey] || "";
        return replaceVariables(translatedKey, params);
    } else {
        if (!translations || Object.keys(translations || {}).length === 0) {
            logTranslationsNotFound();
        }
        return "";
    }
};

// based on granite implementation
const replaceVariables = (text: string = "", snippets: any[]) => {
    if (snippets) {
        if (Array.isArray(snippets)) {
            for (var i = 0; i < snippets.length; i++) {
                text = text.replace("{" + i + "}", snippets[i]);
            }
        } else {
            text = text.replace("{0}", snippets);
        }
    }
    return text;
};

const logTranslationsNotFound = once(() => {
    console.info("no translations found");
});

const translateWithoutContext = (key: string, ...args: any[]) => {
    const possibleState = window?.storeManager?.getState();
    const translations = getTranslations(possibleState);
    return translateKey(translations, key, args);
};

const memoTranslateWithoutContext: (key: string, ...args: any[]) => string =
    memoize(translateWithoutContext, {
        vargs: true,
    });

export {
    replaceVariables,
    translateKey,
    memoTranslateWithoutContext as translateWithoutContext,
};
